'use strict';

function datenum(v, date1904) {
    if (date1904) {
        v+=1462;
    }
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}
 
function sheet_from_array_of_arrays(data, headers) {
    var ws = {};
    var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};

    headers = headers || [];

    for (var R=0; R < headers.length; ++R) {
        var cell_ref = XLSX.utils.encode_cell({c:0,r:R});
        var cell = {v: headers[R], t: 's' };
        ws[cell_ref] = cell;
    }

    for(var R = 0; R != data.length; ++R) {
        for(var C = 0; C != data[R].length; ++C) {
            if(range.s.r > R) { range.s.r = R; }
            if(range.s.c > C) { range.s.c = C; }
            if(range.e.r < R+headers.length) { range.e.r = R+headers.length; }
            if(range.e.c < C) { range.e.c = C; }
            var d = data[R][C];
            var cell = {v: d.value };
            if(cell.v == null) { continue; }
            var cell_ref = XLSX.utils.encode_cell({c:C,r:R+headers.length});

            if (d.format == 'date') {
                if (cell.v) {
                    cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                    cell.v = datenum(cell.v);
                } else {
                    cell.t = 's';
                }
            } else if (d.format == 'price') {
                cell.t = 'n';
            } else {
                cell.t = 's';
            }
            
/*            if(typeof cell.v === 'number') cell.t = 'n';
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
                cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                cell.v = datenum(cell.v);
            }
            else cell.t = 's';*/
            
            ws[cell_ref] = cell;
        }
    }
    if(range.s.c < 10000000) {
        ws['!ref'] = XLSX.utils.encode_range(range);
    }
    return ws;
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
}

function Workbook() {
    if(!(this instanceof Workbook)) {
        return new Workbook();
    }
    this.SheetNames = [];
    this.Sheets = {};
}

/*exported createExcel */
function createExcel(title, data, subtitle) {
    var headers = [title];
    if (subtitle) {
        headers.push(subtitle);
    }
    headers.push('');

    var wb = new Workbook(), ws = sheet_from_array_of_arrays(data, headers);

    /* add worksheet to workbook */
    var invalid_chars = '&:\\/?*[]\"';
    for (var i=0; i < invalid_chars.length; ++i) {
        var char = invalid_chars[i];
        title = title.replaceAll(char, '');
    }

    wb.SheetNames.push(title);
    wb.Sheets[title] = ws;
    var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
    return s2ab(wbout);
}
